// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.export-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 450px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  /* Custom scrollbar */
}
.export-modal::-webkit-scrollbar {
  width: 8px;
}
.export-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.export-modal::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.export-modal::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.export-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
}

.export-modal-options {
  margin-bottom: 20px;
}
.export-modal-options .export-modal-range {
  margin-left: 24px;
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.export-modal-options .export-modal-range input[type=date] {
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.export-modal-options .export-modal-range span {
  align-self: center;
  font-weight: bold;
}

.export-modal-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.export-modal-option input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color);
  margin-right: 8px;
}

.export-modal-desc {
  font-size: 14px;
  color: #666;
  margin-left: 24px;
  line-height: 1.4;
  margin-top: 8px;
  margin-bottom: 12px;
}
.export-modal-desc b {
  color: #1f2937;
  font-weight: 600;
}

.export-modal-content-type {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.export-modal-content-type .content-type-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  margin-top: 0;
}
.export-modal-content-type .content-type-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.export-modal-content-type .content-type-options .content-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.export-modal-content-type .content-type-options .content-type-option:hover {
  background-color: #e9ecef;
}
.export-modal-content-type .content-type-options .content-type-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.export-modal-content-type .content-type-options .content-type-option span {
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
  cursor: pointer;
}
.export-modal-content-type .content-type-options .content-type-option input[type=radio]:checked + span {
  color: #0a3d62;
  font-weight: 600;
}

.additional-columns-section {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #b3d9ff;
  border-radius: 8px;
  background-color: #e6f2ff;
}

.additional-columns-title {
  font-size: 14px;
  font-weight: 600;
  color: #0a3d62;
  margin-bottom: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.additional-columns-title .subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #2d5f8d;
  font-style: italic;
}

.additional-columns-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.column-checkbox {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: white;
  border: 1px solid #b3d9ff;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}
.column-checkbox:hover {
  border-color: #3498db;
  background: #f0f8ff;
  box-shadow: 0 1px 4px rgba(52, 152, 219, 0.15);
}
.column-checkbox input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
  accent-color: #3498db;
}
.column-checkbox span {
  font-size: 13px;
  font-weight: 500;
  color: #0a3d62;
}
.column-checkbox input[type=checkbox]:checked + span {
  color: #2d5f8d;
  font-weight: 600;
}

.selected-columns-info {
  margin-top: 12px;
  padding: 8px 12px;
  background: white;
  border-radius: 4px;
  font-size: 13px;
  color: #2d5f8d;
  font-weight: 500;
  text-align: center;
  border: 1px solid #b3d9ff;
}

.export-modal-orientation {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.export-modal-orientation .orientation-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  margin-top: 0;
}
.export-modal-orientation .orientation-options {
  display: flex;
  gap: 20px;
  align-items: center;
}
.export-modal-orientation .orientation-options .orientation-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.export-modal-orientation .orientation-options .orientation-option:hover {
  background-color: #e9ecef;
}
.export-modal-orientation .orientation-options .orientation-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.export-modal-orientation .orientation-options .orientation-option span {
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
  cursor: pointer;
}
.export-modal-orientation .orientation-options .orientation-option input[type=radio]:checked + span {
  color: #0a3d62;
  font-weight: 600;
}

.orientation-warning {
  margin-top: 10px;
  padding: 8px 12px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  font-size: 12px;
  color: #856404;
  font-weight: 500;
}

.export-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
}
.export-modal-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.export-modal-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.export-modal-actions .btn-print {
  padding: 8px 16px;
  background: #10ac84;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.export-modal-actions .btn-print:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.export-modal-actions .btn-print:not(:disabled):hover {
  background: #0e9770;
}
.export-modal-actions .btn-export {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.export-modal-actions .btn-export:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.export-modal-actions .btn-export:not(:disabled):hover {
  opacity: 0.9;
}

/* Responsive Design */
@media (max-width: 768px) {
  .export-modal {
    padding: 20px;
    max-width: 95%;
  }
  .export-modal-title {
    font-size: 18px;
  }
  .export-modal-range {
    flex-direction: column;
    align-items: stretch;
  }
  .export-modal-range input[type=date] {
    width: 100%;
  }
  .content-type-options {
    flex-direction: column;
  }
  .additional-columns-grid {
    grid-template-columns: 1fr;
  }
  .orientation-options {
    flex-direction: column;
    gap: 8px;
  }
  .export-modal-actions {
    flex-direction: column-reverse;
  }
  .export-modal-actions button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ExportModal/ExportModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EAEA,qBAAA;AAAF;AACE;EACE,UAAA;AACJ;AAEE;EACE,mBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;AAKE;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAHJ;AAKI;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;AAHN;AAMI;EACE,kBAAA;EACA,iBAAA;AAJN;;AASA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AANF;AAQE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,iBAAA;AANJ;;AAUA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPF;AASE;EACE,cAAA;EACA,gBAAA;AAPJ;;AAYA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AATF;AAWE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVJ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AAVN;AAYM;EACE,yBAAA;AAVR;AAaM;EACE,SAAA;EACA,eAAA;EACA,kCAAA;AAXR;AAcM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAZR;AAeM;EACE,cAAA;EACA,gBAAA;AAbR;;AAoBA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjBF;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;AAlBF;AAoBE;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApBJ;AAuBE;EACE,cAAA;EACA,gBAAA;AArBJ;;AAyBA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAtBF;;AA0BA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AAxBN;AA0BM;EACE,yBAAA;AAxBR;AA2BM;EACE,SAAA;EACA,eAAA;EACA,kCAAA;AAzBR;AA4BM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA1BR;AA6BM;EACE,cAAA;EACA,gBAAA;AA3BR;;AAiCA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA9BF;AAgCE;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;AAkCE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAhCJ;AAkCI;EACE,sBAAA;EACA,mBAAA;AAhCN;AAmCI;EACE,mBAAA;AAjCN;AAqCE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAnCJ;AAqCI;EACE,sBAAA;EACA,mBAAA;AAnCN;AAsCI;EACE,YAAA;AApCN;;AAyCA,sBAAA;AACA;EACE;IACE,aAAA;IACA,cAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,sBAAA;IACA,oBAAA;EAxCF;EA0CE;IACE,WAAA;EAxCJ;EA4CA;IACE,sBAAA;EA1CF;EA6CA;IACE,0BAAA;EA3CF;EA8CA;IACE,sBAAA;IACA,QAAA;EA5CF;EA+CA;IACE,8BAAA;EA7CF;EA+CE;IACE,WAAA;EA7CJ;AACF","sourcesContent":[".export-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.export-modal {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 24px;\r\n  width: 90%;\r\n  max-width: 450px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n\r\n  /* Custom scrollbar */\r\n  &::-webkit-scrollbar {\r\n    width: 8px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: #888;\r\n    border-radius: 10px;\r\n\r\n    &:hover {\r\n      background: #555;\r\n    }\r\n  }\r\n}\r\n\r\n.export-modal-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n  color: #333;\r\n}\r\n\r\n.export-modal-options {\r\n  margin-bottom: 20px;\r\n\r\n  .export-modal-range {\r\n    margin-left: 24px;\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-top: 8px;\r\n\r\n    input[type=\"date\"] {\r\n      padding: 4px;\r\n      border: 1px solid #ccc;\r\n      border-radius: 4px;\r\n    }\r\n\r\n    span {\r\n      align-self: center;\r\n      font-weight: bold;\r\n    }\r\n  }\r\n}\r\n\r\n.export-modal-option {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: #333;\r\n  margin-bottom: 8px;\r\n\r\n  input {\r\n    width: 16px;\r\n    height: 16px;\r\n    accent-color: var(--primary-color);\r\n    margin-right: 8px;\r\n  }\r\n}\r\n\r\n.export-modal-desc {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-left: 24px;\r\n  line-height: 1.4;\r\n  margin-top: 8px;\r\n  margin-bottom: 12px;\r\n\r\n  b {\r\n    color: #1f2937;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n// Content Type Selection Styles\r\n.export-modal-content-type {\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  background-color: #f8f9fa;\r\n\r\n  .content-type-title {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n    margin-bottom: 12px;\r\n    margin-top: 0;\r\n  }\r\n\r\n  .content-type-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n\r\n    .content-type-option {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      cursor: pointer;\r\n      padding: 8px 12px;\r\n      border-radius: 6px;\r\n      transition: background-color 0.2s ease;\r\n\r\n      &:hover {\r\n        background-color: #e9ecef;\r\n      }\r\n\r\n      input[type=\"radio\"] {\r\n        margin: 0;\r\n        cursor: pointer;\r\n        accent-color: var(--primary-color);\r\n      }\r\n\r\n      span {\r\n        font-size: 13px;\r\n        color: #4a5568;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n      }\r\n\r\n      input[type=\"radio\"]:checked + span {\r\n        color: #0a3d62;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Additional Columns Section\r\n.additional-columns-section {\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #b3d9ff;\r\n  border-radius: 8px;\r\n  background-color: #e6f2ff;\r\n}\r\n\r\n.additional-columns-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #0a3d62;\r\n  margin-bottom: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n\r\n  .subtitle {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #2d5f8d;\r\n    font-style: italic;\r\n  }\r\n}\r\n\r\n.additional-columns-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.column-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 8px 10px;\r\n  background: white;\r\n  border: 1px solid #b3d9ff;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  user-select: none;\r\n\r\n  &:hover {\r\n    border-color: #3498db;\r\n    background: #f0f8ff;\r\n    box-shadow: 0 1px 4px rgba(52, 152, 219, 0.15);\r\n  }\r\n\r\n  input[type=\"checkbox\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n    margin-right: 8px;\r\n    cursor: pointer;\r\n    accent-color: #3498db;\r\n  }\r\n\r\n  span {\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    color: #0a3d62;\r\n  }\r\n\r\n  input[type=\"checkbox\"]:checked + span {\r\n    color: #2d5f8d;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.selected-columns-info {\r\n  margin-top: 12px;\r\n  padding: 8px 12px;\r\n  background: white;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  color: #2d5f8d;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  border: 1px solid #b3d9ff;\r\n}\r\n\r\n// Orientation Selection Styles\r\n.export-modal-orientation {\r\n  margin-top: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  background-color: #f8f9fa;\r\n\r\n  .orientation-title {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n    margin-bottom: 12px;\r\n    margin-top: 0;\r\n  }\r\n\r\n  .orientation-options {\r\n    display: flex;\r\n    gap: 20px;\r\n    align-items: center;\r\n\r\n    .orientation-option {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      cursor: pointer;\r\n      padding: 8px 12px;\r\n      border-radius: 6px;\r\n      transition: background-color 0.2s ease;\r\n\r\n      &:hover {\r\n        background-color: #e9ecef;\r\n      }\r\n\r\n      input[type=\"radio\"] {\r\n        margin: 0;\r\n        cursor: pointer;\r\n        accent-color: var(--primary-color);\r\n      }\r\n\r\n      span {\r\n        font-size: 13px;\r\n        color: #4a5568;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n      }\r\n\r\n      input[type=\"radio\"]:checked + span {\r\n        color: #0a3d62;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.orientation-warning {\r\n  margin-top: 10px;\r\n  padding: 8px 12px;\r\n  background: #fff3cd;\r\n  border: 1px solid #ffc107;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  color: #856404;\r\n  font-weight: 500;\r\n}\r\n\r\n.export-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 25px;\r\n\r\n  .btn-cancel {\r\n    padding: 8px 16px;\r\n    border: 1px solid #ddd;\r\n    background: white;\r\n    color: #666;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n\r\n    &:hover {\r\n      background-color: #f8f9fa;\r\n    }\r\n  }\r\n\r\n  .btn-print {\r\n    padding: 8px 16px;\r\n    background: #10ac84;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n\r\n    &:disabled {\r\n      background-color: #ccc;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    &:not(:disabled):hover {\r\n      background: #0e9770;\r\n    }\r\n  }\r\n\r\n  .btn-export {\r\n    padding: 8px 16px;\r\n    background: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n\r\n    &:disabled {\r\n      background-color: #ccc;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    &:not(:disabled):hover {\r\n      opacity: 0.9;\r\n    }\r\n  }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .export-modal {\r\n    padding: 20px;\r\n    max-width: 95%;\r\n  }\r\n\r\n  .export-modal-title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .export-modal-range {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n\r\n    input[type=\"date\"] {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .content-type-options {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .additional-columns-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .orientation-options {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .export-modal-actions {\r\n    flex-direction: column-reverse;\r\n\r\n    button {\r\n      width: 100%;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
